"use client";

import React from "react";
import { ArrowLeft, Clock, MapPin, PhoneCall, ShieldCheck, Wrench } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
const trustPoints = [{
  title: "24/7 Immediate Dispatch",
  description: "Emergency crews stationed nearby for rapid arrival.",
  icon: Clock
}, {
  title: "Licensed & Insured",
  description: "Experienced technicians ready for residential & commercial jobs.",
  icon: ShieldCheck
}, {
  title: "Upfront Estimates",
  description: "Clear pricing with no unexpected hidden trip charges.",
  icon: Wrench
}];
export default function StockbridgeCTA() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="stockbridgeclosingcta" data-nav="light" className="bg-background text-foreground py-16 md:py-24 border-t border-border">
      <div className="container mx-auto px-4 max-w-5xl">
        <motion.div initial={{
        opacity: 0,
        y: shouldReduceMotion ? 0 : 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="relative overflow-hidden rounded-2xl border border-border bg-card text-card-foreground p-8 md:p-12 shadow-lg">
          {/* Decorative background accent circle */}
          <div className="pointer-events-none absolute -right-24 -top-24 size-96 rounded-full bg-primary/5 blur-3xl" />
          <div className="pointer-events-none absolute -left-24 -bottom-24 size-96 rounded-full bg-accent/10 blur-3xl" />

          <div className="relative z-10 flex flex-col items-center text-center">
            <Badge variant="secondary" className="mb-4 gap-1.5 px-3 py-1 text-xs">
              <MapPin className="size-3.5 text-primary" />
              Stockbridge, GA Local Service
            </Badge>

            <h2 className="font-default text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl max-w-3xl">
              Need Plumbing Service in Stockbridge? Contact Us Today
            </h2>

            <p className="mt-4 max-w-2xl text-muted-foreground text-base md:text-lg leading-relaxed">
              From burst pipes and water heater breakdowns to clogged sewer mains, our Stockbridge emergency plumbers arrive equipped to resolve your plumbing problems immediately.
            </p>

            {/* Primary Action Buttons */}
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
              <Button size="lg" asChild className="w-full sm:w-auto font-semibold shadow-md bg-primary text-primary-foreground hover:bg-primary/90">
                <a href="tel:4708479076" className="flex items-center gap-2">
                  <PhoneCall className="size-5" />
                  <span>Call (470) 847-9076</span>
                </a>
              </Button>

              <Button size="lg" variant="outline" asChild className="w-full sm:w-auto font-medium border-border hover:bg-accent hover:text-accent-foreground">
                <Link to="/contact/">Request Service Online</Link>
              </Button>
            </div>

            {/* Trust Badges */}
            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 w-full text-left pt-8 border-t border-border/80">
              {trustPoints.map((point, index) => {
              const Icon = point.icon;
              return <div key={point.title} data-index={index} className="flex items-start gap-3.5 p-3 rounded-lg bg-background/50 border border-border/50">
                    <div className="p-2 rounded-md bg-secondary text-secondary-foreground shrink-0 mt-0.5">
                      <Icon className="size-4 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-default text-sm font-semibold text-foreground">
                        {point.title}
                      </h3>
                      <p className="text-xs text-muted-foreground mt-0.5">
                        {point.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>

            {/* Hub Navigation Link */}
            <div className="mt-8">
              <Link to="/service-areas/" className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors group">
                <ArrowLeft className="size-4 transition-transform group-hover:-translate-x-1" />
                <span>View All Service Areas</span>
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}